import { render, staticRenderFns } from "./in-the-media.vue?vue&type=template&id=3c628dcd&scoped=true&"
import script from "./in-the-media.vue?vue&type=script&lang=js&"
export * from "./in-the-media.vue?vue&type=script&lang=js&"
import style0 from "./in-the-media.vue?vue&type=style&index=0&id=3c628dcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c628dcd",
  null
  
)

export default component.exports